import styled from "styled-components";
import { ImageProps } from "./image.types";

export const ImageStyled = styled.div<ImageProps>`
  img {
    width: ${({ width }): string => width || "45px"};
    height: ${({ height }): string => height || "41px"};
  }
`;
